<template>
	<div v-if="loading" class="text-center">
	    Loading PDF Builder <i class="fa fa-circle-o-notch fa-spin"></i>
	</div>
	<div v-else>
		<div>
			<vue-headful :title="'Build PDF [INSP-'+inspection.InspectionId+'-Date-'+inspection.InspectionDate+'-Jobsite-'+inspection.JobsiteNumber+'] :: MeritEHS'"/>

			<h4 class="py-3 mb-4">
			    <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			            <router-link :to="`/inspections`">
			                <i class="fa fa-list"></i> Inspections
			            </router-link>
			        </li>
			        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			            <router-link :to="`/inspections/view/${inspection.InspectionId}`">
			                <inspection-name :inspection="inspection" />
			            </router-link>
			        </li>
			        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">Build PDF</li>
			    </ol>
			</h4>

			<div class="row">
				<div class="col-xl-8 col-lg-10 col-12">
					<div class="card">
						<div class="card-header">
							Inspection PDF
						</div>
						<div class="card-body">
							<div class="mb-4">
							    <strong>PDF Settings:</strong>
							    <ol>
							        <li class="mb-1" v-if="pdfLogo">
							            <span>Show/Hide Logo:</span>
							            <select v-model="showLogo">
							                <option :value="true">Show Logo</option>
							                <option :value="false">Hide Logo</option>
							            </select>
							            <span class="small">Show/Hide your company logo on the Inspection PDF report.</span>
							        </li>

							        <li class="mb-1">
							            <span>Show/Hide {{ labelCompliant }}:</span>
							            <select v-model="showCompliant">
							                <option :value="true">Show {{ labelCompliant }}</option>
							                <option :value="false">Hide {{ labelCompliant }}</option>
							            </select>
							            <span class="small">You can hide the {{ labelCompliant }} items if you want to create a {{ labelNonCompliant }} Only PDF.</span>
							        </li>
							        <li class="mb-1" v-if="showCompliant == 1">
							            <span>Show/Hide N/A:</span>
							            <select v-model="hideNA">
							                <option :value="false">Show N/A</option>
							                <option :value="true">Hide N/A</option>
							            </select>
							            <span class="small">You can hide the {{ labelNonCompliant }} items if you want to create a {{ labelCompliant }} Only PDF.</span>
							        </li>
							        <li class="mb-1" v-if="enable_insp_scmm == 1">
							            <span>Show/Hide Safety Comittee Sections:</span>
							            <select v-model="showSafetyCommittee">
							                <option :value="true">Show Safety Committee</option>
							                <option :value="false">Hide Safety Committee</option>
							            </select>
							            <span class="small"></span>
							        </li>
							        <li class="mb-1" v-if="custom_field_sections != null && custom_field_sections.length > 0">
							            <span>Show/Hide Custom Fields</span>
							            <select v-model="showCustomFields">
							                <option :value="true">Show Custom Fields</option>
							                <option :value="false">Hide Custom Fields</option>
							            </select>
							            <span class="small">You can hide the Safety Committee, Minues, Options/Questions.</span>
							        </li>
							    </ol>
							</div>

							<div>
							    <strong>PDF:</strong>
							    <template v-if="building">
							    	Building PDF <i class="fa fa-circle-o-notch fa-spin"></i>
							    </template>
							    <template v-else-if="file_name">
							    	<a :href="`/files/pdf/${file_name}`" target="_blank" title="Preview PDF">{{ file_name }}</a>
							    </template>
							</div>
						</div>
						<div class="card-footer">
							<button class="btn btn-sm btn-info d-sm-inline-block d-block mb-sm-0 mb-1" v-on:click="buildPDF()" :disabled="building || sending">
								<template v-if="!building">Build PDF</template>
								<template v-else><i class="fa fa-spin fa-spinner"></i> Building PDF</template>
							</button>

							<template v-if="file_name">
								<a :href="`/files/pdf/${file_name}`"
									target="_blank"
									title="Download PDF"
									class="btn btn-sm btn-default mb-sm-0 mb-1"
									:disabled="building || sending">
									Download PDF
								</a>
								<button
									class="btn btn-sm btn-default d-sm-inline-block d-block mb-sm-0"
									v-on:click="sendEmail()"
									:disabled="building || sending">
									Email PDF to Me ({{ $store.state.user.email }})
								</button>
							</template>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import moment from 'moment-timezone';

	export default {
	    data: function() {
	        return {
	            loading: true,
	            building: false,
	            sending: false,
	            InspectionId: this.$route.params.id,
	            inspection: {},
	            errors: {},
	            insp_config: null,
	            configs: [],
	            options: [],
	            file_name: null,
	            file_path: null,

	            showLogo: true,
	            showCustomFields: true,
	            showCompliant: true,
	            hideNA: false,
	            showSafetyCommittee: true,
	            files: [],
	            imagesLoading: false,
	            pdfs_proccessing: false,
	            result_labels: null,
	            pdfLogo: null,
	            custom_field_sections: [],
	            personnel: [],
	            enable_insp_scmm: null,

	            //Email Config
	            subject: null,
	            email_body: null,
	            to: [
	            	this.$store.state.user.email,
	            ],
	        }
	    },

	    watch: {
	    	showLogo(newVal, oldVal){
	    		//Reset the Values
	    		this.file_name = null;
	    		this.file_path = null;
	    	},

	    	showCustomFields(newVal, oldVal){
	    		//Reset the Values
	    		this.file_name = null;
	    		this.file_path = null;
	    	},

	    	showCompliant(newVal, oldVal){
	    		//Reset the Values
	    		this.file_name = null;
	    		this.file_path = null;
	    	},

	    	hideNA(newVal, oldVal){
	    		//Reset the Values
	    		this.file_name = null;
	    		this.file_path = null;
	    	},

	    	showSafetyCommittee(newVal, oldVal){
	    		//Reset the Values
	    		this.file_name = null;
	    		this.file_path = null;
	    	},
	    },

	    computed: {
	    	owner_name(){
	    		//Check value
	    		if(this.inspection.hide_creator == 1 && !this.$store.state.user.is_admin)
	    		{
	    			return '';
	    		}

	    		//Check ID
	    		if(this.inspection.CreatedByUserId)
	    		{
	    			//Default
	    			return this.inspection.owner_first_name+' '+this.inspection.owner_last_name;
	    		}

	    		//Check ID
	    		if(this.inspection.CreatedByEmployeeId)
	    		{
	    			//Default
	    			return this.inspection.EmpFirstName+' '+this.inspection.EmpLastName;
	    		}

	    		//Defulat
	    		return '';
	    	},

	    	labelCompliant(){
	    	    //Check if set
	    	    if(this.result_labels && this.result_labels.compliant)
	    	    {
	    	        return this.result_labels.compliant;
	    	    }

	    	    //Default
	    	    return 'Compliant';
	    	},

	    	labelNonCompliant(){
	    	    //Check if set
	    	    if(this.result_labels && this.result_labels.noncompliant)
	    	    {
	    	        return this.result_labels.noncompliant;
	    	    }

	    	    //Default
	    	    return 'Non-Compliant';
	    	},

	    	labelNA(){
	    	    //Check if set
	    	    if(this.result_labels && this.result_labels.na)
	    	    {
	    	        return this.result_labels.na;
	    	    }

	    	    //Default
	    	    return 'N/A';
	    	},

	    	sectionNonCompliant(){
	    	    //Setup a local array
	    	    var sections = [];

	    	    //Loop
	    	    for (var i = 0; i < this.sections.length; i++)
	    	    {
	    	        //Set a local help of has been added
	    	        var sectionAdded = false;

	    	        //Loop through the elements
	    	        for (var j = 0; j < this.sections[i]['elements'].length; j++)
	    	        {
	    	            //Check for compliance
	    	            if(this.sections[i]['elements'][j]['ComplianceStatusId'] == 2)
	    	            {
	    	                //Check if the section has been added
	    	                if(!sectionAdded)
	    	                {
	    	                    //Build the formatted section
	    	                    var formattedSection = {
	    	                        CreatedBy: this.sections[i]['CreatedBy'],
	    	                        Description: this.sections[i]['Description'],
	    	                        DisplayOrder: this.sections[i]['DisplayOrder'],
	    	                        InspectionSectionId: this.sections[i]['InspectionSectionId'],
	    	                        IsActive: this.sections[i]['IsActive'],
	    	                        ModifiedBy: this.sections[i]['ModifiedBy'],
	    	                        SectionName: this.sections[i]['SectionName'],
	    	                        SmartBizClientId: this.sections[i]['SmartBizClientId'],
	    	                        created_at: this.sections[i]['created_at'],
	    	                        elements: [],
	    	                    };

	    	                    //Push it onto the array
	    	                    sections.push(formattedSection);

	    	                    //Set the helper
	    	                    sectionAdded = true;
	    	                }

	    	                //Push onto the array
	    	                sections[(sections.length - 1)]['elements'].push(this.sections[i]['elements'][j]);
	    	            }
	    	        }
	    	    }

	    	    //Send it
	    	    return sections;
	    	},

	    	sectionCompliant(){
	    	    //Setup a local array
	    	    var sections = [];

	    	    //Loop
	    	    for (var i = 0; i < this.sections.length; i++)
	    	    {
	    	        //Set a local help of has been added
	    	        var sectionAdded = false;

	    	        //Loop through the elements
	    	        for (var j = 0; j < this.sections[i]['elements'].length; j++)
	    	        {
	    	            //Check for compliance
	    	            if(this.sections[i]['elements'][j]['ComplianceStatusId'] != 2 && (this.hideNA == false || this.sections[i]['elements'][j]['ComplianceStatusId'] == 1))
	    	            {
	    	                //Check if the section has been added
	    	                if(!sectionAdded)
	    	                {
	    	                    //Build the formatted section
	    	                    var formattedSection = {
	    	                        CreatedBy: this.sections[i]['CreatedBy'],
	    	                        Description: this.sections[i]['Description'],
	    	                        DisplayOrder: this.sections[i]['DisplayOrder'],
	    	                        InspectionSectionId: this.sections[i]['InspectionSectionId'],
	    	                        IsActive: this.sections[i]['IsActive'],
	    	                        ModifiedBy: this.sections[i]['ModifiedBy'],
	    	                        SectionName: this.sections[i]['SectionName'],
	    	                        SmartBizClientId: this.sections[i]['SmartBizClientId'],
	    	                        created_at: this.sections[i]['created_at'],
	    	                        elements: [],
	    	                    };

	    	                    //Push it onto the array
	    	                    sections.push(formattedSection);

	    	                    //Set the helper
	    	                    sectionAdded = true;
	    	                }

	    	                //Push onto the array
	    	                sections[(sections.length - 1)]['elements'].push(this.sections[i]['elements'][j]);
	    	            }
	    	        }
	    	    }

	    	    //Send it
	    	    return sections;
	    	},

	    	images(){
	    	    //Make sure we only pass images
	    	    var types = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];

	    	    //Setup
	    	    var imageFiles = [];

	    	    //loop
	    	    for(var i in this.files)
	    	    {
	    	        if(types.indexOf(this.files[i].file_extension.toLowerCase()) !== -1)
	    	        {
	    	            imageFiles.push(this.files[i]);
	    	        }
	    	    }

	    	    //Send it
	    	    return imageFiles;
	    	},

	    	nonImages(){
	    	    //Make sure we only pass images
	    	    var types = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];

	    	    //Setup
	    	    var files = [];

	    	    //loop
	    	    for(var i in this.files)
	    	    {
	    	        if(types.indexOf(this.files[i].file_extension.toLowerCase()) === -1)
	    	        {
	    	            files.push(this.files[i]);
	    	        }
	    	    }

	    	    //Send it
	    	    return files;
	    	}
	    },

	    methods: {

	        getInspection() {
	        	//Build the URL
	        	var url = '/inspections/view/' + this.InspectionId + '?pdf=true';

	        	//Check for Inspection GUID
	        	if(isNaN(this.InspectionId))
	        	{
	        	    //Send it
	        	    url = '/inspections/pdf-by-guid/' + this.InspectionId;
	        	}

	        	//Get the data
	        	this.$http
	        	    .get(url)
	        	    .then(response => {
	        	        //Set all the data
	        	        this.inspection = response.data.inspection;
	        	        this.sections = response.data.sections;
	        	        this.safety_committee_members = JSON.parse(this.inspection['safety_committee_members']);
	        	        this.files = response.data.files;
	        	        this.pdfs_proccessing = response.data.pdfs_proccessing;
	        	        this.pdfLogo = response.data.pdfLogo;
	        	        this.personnel = response.data.personnel;
	        	        this.enable_insp_scmm = response.data.enable_insp_scmm;

	        	        //Check for Result Labels
	        	        if(this.inspection.result_labels)
	        	        {
	        	            this.result_labels = JSON.parse(this.inspection.result_labels);
	        	        }

	        	        //Check for Result Labels
	        	        if(response.data.custom_field_sections)
	        	        {
	        	            //Set the Custom Fields
	        	            this.custom_field_sections = response.data.custom_field_sections;
	        	        }

	        	        //Set Some Email Config Stuff
	        	        //Set the Subject
	        	        this.subject = 'MeritEHS PDF for INSP-'+this.InspectionId+' on '+this.inspection.InspectionDate+' for '+this.inspection.JobsiteName;
	        	        this.email_body = 'Inspection: '+this.InspectionId+'\n'+
	        	        					'Date: '+this.inspection.inspection_date_formatted+'\n'+
	        	        					'Inspected By: '+this.owner_name+'\n'+
	        	        					'Jobsite: '+this.inspection.JobsiteNumber+' - '+this.inspection.JobsiteName+'\n\n'+
	        	        					'See attached PDF for Results';
	        	    })
	        	    .catch(response => {

	        	    })
	        	    .then(() => {
	        	    	//Reset Loading
	        	    	this.loading = false;
	        	    });
	        },

	        buildPDF(){
	        	//Helper
	        	this.building = true;

	        	//Build the Payload
	        	var payload = {
	        		hide_na_items: this.hideNA,
			    	show_logo: this.showLogo,
			    	show_custom_fields: this.showCustomFields,
			    	show_compliant: this.showCompliant,
			    	show_safety_committee: this.showSafetyCommittee,
			    	load_config: false,
	        	};

	            //Get the data
	            this.$http
	                .get('/inspections/email-pdf/'+this.InspectionId, payload)
	                .then(response => {
		                //Set all the data
		                this.file_path = response.data.file_path;
		                this.file_name = response.data.file_name;

	                })
	                .catch(response => {

	                })
	                .then(() => {
	                	//Reset
	                	this.loading = false;
	                	this.building = false;
	                });
	        },

			sendEmail() {
			    //Show loading
			    this.sending = true;

			    //Reset the errors
			    this.errors = {};

			    //Setup
			    var payload = {
			    	subject: this.subject,
			    	email_body: this.email_body,
			    	to: this.to,
			    	file_path: this.file_path,
			    };

			    //Get the data
			    this.$http
			        .post('/inspections/email-pdf/'+this.InspectionId, payload)
			        .then(response => {
			            //Alert
			            this.$toastr.success('PDF Sent. Check your email.');

			            //Push back
			            //this.$router.push('/inspections/view/'+this.InspectionId);
			        })
			        .catch(error => {
			        	//Check for error
			        	if(error.response.status === 422)
			        	{
			        	    //Display validation errors
			        	    this.errors = error.response.data
			        	}
			        	else
			        	{
			        	    //Alert the user
			        	    this.$toastr.error(error.response.data, 'Failed to Email Inspection PDF');
			        	}
			        })
			        .then(() => {
			        	//Reset
			        	this.sending = false;
			        });
			},
	    },

	    mounted() {
	        //Get the inspections
	        this.getInspection();
	    },
	}
</script>